export const settingZoneExplain = parentVue => {
    return {
        description: "<p>Roles</p>"
    };
};



// WEBPACK FOOTER //
// ./src/view/RolesManage/fields.js